<template>
        <div class=''>

            <vue-form :name="'team-'+teamId" :fields="questions" @change="updateInfo">  
            </vue-form>

        </div>
</template>

<script>
import _ from 'lodash';
export default {
    data(){
        return {
            formstate: {},
            model:{},
            infos:{},
        }
    },
    created:function(){
    },

    props:{
        teamId:{
            // type: Number,
            default:0
        },
    },

    computed:{
        team:function(){
            return this.$store.getters['OrderStore/teamByID'](this.teamId)
        },
        questions:function(){
            return _.map(this.team.questions, question =>{
                let questionForForm = {...question}
                // change labem and key to correct question format
                questionForForm.label = question.name+""; //+"" to create new string, not just ref it
                questionForForm.name = question.key
                questionForForm.value = _.get(this.team.infos,question.key,'')
                return questionForForm;  
            })
        
        }
    },
   
    methods: {
        updateInfo:function(values){
            this.infos = values;
            this.$store.commit('OrderStore/updateTeamInfo',{ teamId:this.teamId, infos:values })
            this.$store.commit('PurchaseStore/updateTeamInfo',{ teamId:this.teamId, infos:values })
        }
    }

    

}
</script>

<style lang="stylus">

    .member{
        background:rgba(#17a2b8,0.1)
        padding: 2em 1em;
        border-radius 10px;
        }


</style>
